import { trigger, style, transition, animate } from '@angular/animations';
import { AfterViewInit, Component, Input, OnChanges, OnDestroy, signal, SimpleChanges } from '@angular/core';
import { faPause, faPlay } from '@fortawesome/pro-solid-svg-icons';

import WaveSurfer from 'wavesurfer.js';

import { WaveConfigOptions } from '@empathy/audio';

@Component({
  selector: 'empathy-local-audio-player',
  templateUrl: 'local-audio-player.component.html',
  styleUrls: ['./local-audio-player.component.scss'],
  animations: [
    trigger('rotateInOut', [
      transition(':enter', [style({ transform: 'rotate(-90deg)' }), animate('100ms', style({ transform: 'rotate(0deg)' }))]),
      transition(':leave', [style({ transform: 'rotate(-90deg)' }), animate('100ms', style({ transform: 'rotate(0deg)' }))])
    ])
  ]
})
export class LocalAudioPlayerComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() audio: Blob;
  @Input() id: number | string;

  paused$ = signal(true);

  faPause = faPause;
  faPlay = faPlay;

  private audioSettings: WaveConfigOptions = {
    autoScroll: true,
    autoCenter: true,
    dragToSeek: true,
    fillParent: true,
    barGap: 2,
    barRadius: 10,
    barWidth: 2,
    cursorColor: 'rgba(172, 212, 52, 1)',
    cursorWidth: 2,
    height: 24,
    normalize: false,
    progressColor: 'rgb(255, 255, 255)',
    waveColor: 'rgb(0, 0, 0)'
  };
  private waveSurfer: WaveSurfer;
  private audioUrl: string | null = null;

  ngAfterViewInit(): void {
    this.createWaveSurfer();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.audio && !changes.audio.firstChange) {
      this.createWaveSurfer();
    }
  }

  ngOnDestroy(): void {
    this.destroyWaveSurfer();
  }

  onPlayPause(): void {
    this.waveSurfer.playPause();
  }

  private createWaveSurfer(): void {
    this.destroyWaveSurfer();
    this.audioUrl = URL.createObjectURL(this.audio);

    this.waveSurfer = WaveSurfer.create({
      container: document.getElementById(`audio_${this.id}`),
      autoCenter: this.audioSettings.autoCenter,
      dragToSeek: this.audioSettings.dragToSeek,
      fillParent: this.audioSettings.fillParent,
      normalize: this.audioSettings.normalize,
      waveColor: this.audioSettings.waveColor,
      progressColor: this.audioSettings.progressColor,
      cursorColor: this.audioSettings.cursorColor,
      height: this.audioSettings.height,
      cursorWidth: this.audioSettings.cursorWidth,
      barWidth: this.audioSettings.barWidth,
      barGap: this.audioSettings.barGap,
      barRadius: this.audioSettings.barRadius,
      barHeight: this.audioSettings.barHeight,
      url: this.audioUrl
    });

    this.waveSurfer.on('pause', () => this.paused$.set(true));
    this.waveSurfer.on('play', () => this.paused$.set(false));
  }

  private destroyWaveSurfer(): void {
    if (this.waveSurfer) {
      this.waveSurfer.unAll();
      this.waveSurfer.destroy();
    }
    this.waveSurfer = null;

    if (this.audioUrl) {
      URL.revokeObjectURL(this.audioUrl);
      this.audioUrl = null;
    }
  }
}
